module.exports = __webpack_public_path__ + "img/wd-bg2-c5483c.png";